export class ComboEmpresaSocial {
	
	idEntidadeSocial:number;                 
	id:number;       
 	nomeRazaoSocial:string;
	     
}